import { ValiError } from 'valibot';

import { API } from '@/api';
import { fetcher, HTTPError, logger } from '@/services/fetcher';

import { type CitiesParams, citiesApiSchema } from '../../models';

const primaryApi = fetcher.extend(() => ({ prefixUrl: `${API.PRIMARY}` }));

export const fetchCities = async (params: CitiesParams, { signal }: { signal?: AbortController['signal'] } = {}) => {
  try {
    return await primaryApi
      .get('GetCities', { searchParams: { CountryCode: params.CountryCode, StateCode: params.StateCode }, signal })
      .json(citiesApiSchema);
  } catch (error) {
    if (error instanceof ValiError || (error instanceof Error && error.name === 'ValiError')) {
      logger.warn('Validation error on cities response', (error as ValiError<typeof citiesApiSchema>).issues);
    }
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
